import { useEffect, useRef } from "react";

import useOrderFormik from "../useOrderFormik";

const SCROLL_OFFSET = -100;

const useScrollToError = (): void => {
  const { errors, submitCount } = useOrderFormik();
  const prevSubmitCountRef = useRef<number | null>(null);

  useEffect(() => {
    const errorFieldNames = Object.keys(errors).filter((fieldName) => !!errors[fieldName]);
    if (prevSubmitCountRef.current === submitCount || !errorFieldNames.length) {
      return;
    }
    prevSubmitCountRef.current = submitCount;

    const firstErrorFieldName = errorFieldNames[0];

    const selector = `[data-field="${firstErrorFieldName}"]`;
    const errorElement = document.querySelector(selector) as HTMLElement;

    if (!errorElement) {
      return;
    }

    const y = errorElement.getBoundingClientRect().top + window.pageYOffset + SCROLL_OFFSET;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, [errors, submitCount]);
};
export default useScrollToError;
